import { trackingService } from '../TrackingService';
import { extractData } from './extractors';

export class TrackingController {
  static shouldTrack(globalEnabled: boolean, widgetEnabled: boolean): boolean {
    return globalEnabled && widgetEnabled;
  }
  
  static trackWidgetAction(
    widgetName: string,
    action: string, 
    eventName: string,
    eventType: string,
    data: any,
    globalEnabled: boolean,
    widgetEnabled: boolean,
    extractorType: string = 'raw',
    priority: string = '2'
  ) {
    if (!this.shouldTrack(globalEnabled, widgetEnabled)) {
      return; 
    }
    
    const details = extractData(data, extractorType);
    trackingService.recordEvent(action, eventName, eventType, widgetName, details, priority);
  }
}